import './scss/_testimonials.css';
export default function Testimonials() {
    const checklist = [
        {title: "Grundig forståelse av fotproblemer", text: "Vi jobber ikke bare med symptomene, men søker den egentlige årsaken til ubehag – gangens biomekanikk, belastning eller individuelle egenskaper ved føttene."},
        {title: "Trygge og klinisk dokumenterte metoder", text: "Alle prosedyrer utføres i henhold til profesjonelle standarder og med bruk av sterilt utstyr og moderne behandlingsteknikker."},
        {title: "Personlig behandlingsplan", text: "Hver fot er unik, derfor utarbeider vi en individuell behandlingsplan som tar hensyn til din tilstand, livsstil og forebygging på lang sikt."},
        {title: "Omsorg uten hastverk", text: "Vi setter av god tid til hver pasient. Vi forklarer hvert steg i behandlingen, slik at du føler deg trygg og ivaretatt."},
        {title: "Skånsomhet og komfort", text: "Vi sørger for maksimal komfort under behandlingen og respekterer dine grenser – uten smerte, stress eller hastverk."},
        {title: "Oppfølging etter behandling", text: "Du får tydelige råd og oppfølging etter timen, slik at resultatet blir stabilt og langvarig."},
    ];
    const checklist2 = [
        {title: "Omsorg uten hastverk", text: "Vi setter av god tid til hver pasient. Vi forklarer hvert steg i behandlingen, slik at du føler deg rolig og trygg."},
        {title: "Skånsomhet og komfort", text: "Vi sørger for maksimal komfort under behandlingen og respekterer dine opplevelser og grenser – uten smerte, stress eller hastverk."},
        {title: "Oppfølging etter behandling", text: "Du får tydelige anbefalinger og oppfølging etter timen, slik at resultatet blir stabilt og langvarig."},
    ];
    const feedbacks = [
        { name: "Anna As****", img: "./stars5.svg", text: "Veldig profesjonell og hyggelig fotterapeut!" },
        { name: "Jonas St*******", img: "./stars4.svg", text: "Behandlingen hjalp meg enormt!" },
        { name: "Maria Ar*** Jo***", img: "./stars5.svg", text: "Anbefales på det sterkeste!" },
        { name: "Jorun Vo****", img: "./stars3.svg", text: "Veldig bra!!!" },
    ];


    return (
        <section id="testimonials">
            <div className="cs-container">

                <div className="block-choose">
                    <div className="cs-content">
                        <h2 className="text-3xl font-bold mb-8">Kvalitet i hver behandling</h2>
                        <ul className="cs-ul">
                        {checklist.map((f, idx) => (
                            <li key={idx} className="cs-li">
                                <img className="cs-icon" aria-hidden="true" loading="lazy" decoding="async" src="../check.svg" width="27" height="27"/>
                                {f.title}
                            </li>
                        ))}
                        </ul>
                    </div>
                    <div className="cs-right">
                        <picture className="cs-picture cs-picture1" aria-hidden="true">
                            <source media="(max-width: 600px)"
                                    srcSet="./kontor.jpg"/>
                            <source media="(min-width: 601px)"
                                    srcSet="./kontor.jpg"/>
                            <img loading="lazy" decoding="async"
                                 src="./kontor.jpg"
                                 alt="Kontor" width="672" height="672"/>
                        </picture>
                        <picture className="cs-picture cs-picture2" aria-hidden="true">
                            <source media="(max-width: 600px)"
                                    srcSet="./instruments.jpg"/>
                            <source media="(min-width: 601px)"
                                    srcSet="./instruments.jpg"/>
                            <img loading="lazy" decoding="async"
                                 src="./instruments.jpg"
                                 alt="Instruments" width="300" height="300"/>
                        </picture>
                        <picture className="cs-picture cs-picture3" aria-hidden="true">
                            <source media="(max-width: 600px)"
                                    srcSet="./sueda-creams.jpg"/>
                            <source media="(min-width: 601px)"
                                    srcSet="./sueda-creams.jpg"/>
                            <img loading="lazy" decoding="async"
                                 src="./creams.jpg"
                                 alt="Creams" width="200" height="200"/>
                        </picture>
                    </div>
                </div>
            <div className="carousel w-full flex overflow-x-auto gap-6 px-6">
                <ul className="cs-card-group">
                {feedbacks.map((f, idx) => (
                    <li key={idx} className="cs-item">
                        <img className="cs-stars" aria-hidden="true"
                             src={f.img} decoding="async" width="189" height="24"/>
                            <p className="cs-item-text">{f.text}</p>
                            <div className="cs-flex-group">
                                 <span className="cs-job">{f.name}</span>
                            </div>
                    </li>
                ))}
                </ul>
            </div>
            </div>
        </section>
    );
}